/*
创建者 魏强(2018.1.25)
企业品牌
*/
<template>
	<div class="home-module">
            <h3 class="module-title"><span>企业品牌</span></h3>
            <div class="module-brand">
            	<left-ad 
            		:qyLeftUpAdv="qyLeftUpAdv"
            		:qyLeftDownAdv="qyLeftDownAdv"
            	></left-ad>
            	<middle-ad
            		:qyMiddleUpAdv="qyMiddleUpAdv"
            		:qyMiddleMiddleAdv="qyMiddleMiddleAdv"
            		:qyMiddleDownAdv="qyMiddleDownAdv"
            	></middle-ad>
            	<right-ad :qyRightGoodsAdv="qyRightGoodsAdv"></right-ad>
            </div>
        </div>
</template>
<script>
import leftAd  from './left-ad/index.vue';
import middleAd  from './middle-ad/index.vue';
import rightAd  from './right-ad/index.vue';
export default {
	components:{
		leftAd,middleAd,rightAd
	},
	props:["qyLeftUpAdv",
	"qyLeftDownAdv",
	"qyMiddleUpAdv",
	"qyMiddleMiddleAdv",
	"qyMiddleDownAdv",
	"qyRightGoodsAdv"
	],
	data(){
		return {
			value:0	
		}
	}
}
</script>


// WEBPACK FOOTER //
// index.vue?aa56b7c0